export const getPlaceholderLettersByName = (name: string) => {
  const singleWords = name.split(" ");
  if (singleWords.length == 1) {
    return singleWords[0].charAt(0).toUpperCase();
  }
  return singleWords[0].charAt(0).toUpperCase() + singleWords[1].charAt(0).toUpperCase();
};
